import lifecycle from 'recompose/lifecycle';

const hoc = lifecycle({
  shouldComponentUpdate() {
    return false;
  }
});

export default hoc


// WEBPACK FOOTER //
// ./public/hoc/blockParentUpdates.jsx